import type { Shape } from '../common/commonTypes'

export interface QueryResult {
  govCode: string
  type: string
  districtId: string
  prefCode: string
  prefName: string
  cityCode: string
  cityName: string
  streetCode: string
  streetName: string
  blockNumber: string
  location: number[]
  quadkey: string
  shape: Shape
  srid: string
  isDeleted: boolean
}

export interface ResQueryAdminDistricts {
  result: QueryResult[]
  lastEvaluatedKey?: object
}

export interface ArgQueryAdminDistricts {
  govCode: string
  type: string
  lat?: number
  lng?: number
  radius?: number
  cityCode?: string
  streetCode?: string
  prefCode?: string
  blockNumber?: string
  projection?: string
  exclusiveStartKey?: object
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isArgQueryAdminDistricts = (arg: any): arg is ArgQueryAdminDistricts =>
  typeof arg.govCode === 'string' &&
  typeof arg.type === 'string' &&
  (typeof arg.lat === 'undefined' || typeof arg.lat === 'number') &&
  (typeof arg.lng === 'undefined' || typeof arg.lng === 'number') &&
  (typeof arg.radius === 'undefined' || typeof arg.radius === 'number') &&
  (typeof arg.cityCode === 'undefined' || typeof arg.cityCode === 'string') &&
  (typeof arg.streetCode === 'undefined' || typeof arg.streetCode === 'string') &&
  (typeof arg.prefCode === 'undefined' || typeof arg.prefCode === 'string') &&
  (typeof arg.blockNumber === 'undefined' || typeof arg.blockNumber === 'string') &&
  (typeof arg.projection === 'undefined' || typeof arg.projection === 'string')
